<template>
  <Modal>
    <Modal.Title>Dacr Membership</Modal.Title>
    <DacrMembershipBody desktop />
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'

import DacrMembershipBody from './DacrMembershipBody.vue'
</script>
